import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { array, concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';

interface Signature {
  Args: {
    form: ForcProviderBaseSignature['Blocks']['default'][0];
  };
}

const MiciBaseConsultFormBloodInStoolFrequency: TemplateOnlyComponent<Signature> =
  <template>
    {{#if @form.changeset.bloodInStool}}
      <@form.FieldsRadioGroup
        @propertyName='bloodInStoolFrequency'
        @title={{t 'mici-form.bloodInStoolFrequency.long' htmlSafe=true}}
        as |Group|
      >
        {{#each (array '1' '2' '3') as |value|}}
          <Group.FieldRadio
            @value={{value}}
            @label={{t
              (concat 'mici-form.bloodInStoolFrequency.answers.' value)
            }}
          />
        {{/each}}
      </@form.FieldsRadioGroup>
    {{/if}}
  </template>;

export default MiciBaseConsultFormBloodInStoolFrequency;
